import { AddOnCardDataProps, FEATURE_NAMES, IPlan, TFEATURE_NAMES } from '@/types';
import {
  ANALYTICS_PERIOD,
  AppearanceFormValues,
  IChatBot,
  Message,
  MessageTypeValues,
  TANALYTICS_PERIOD,
} from '@/types/entities/chatbot.entities';
import { IChatLogs } from '@/types/entities/chatlogs.entities';
import { ISource, SOURCE_STATUS } from '@/types/entities/source.entites';
import { IStaff } from '@/types/entities/staff.entities';
import { IFeatureUsage } from '@/types/entities/user.entities';

export const ACCESS_TOKEN = 'auth-token';
export const REFRESH_TOKEN = 'auth-refresh-token';
// The Shopify store the current session was handed off from. Set during the
// Shopify dashboard handoff; used to target Shopify billing/upgrade links at
// the merchant's own store instead of shopifyInstallations[0].
export const SHOPIFY_CURRENT_SHOP = 'shopify-current-shop';
export const KEEP_ME_LOGGED_IN = 'auth-keep-me-logged-in';
export const CONVERSATION_COOKIE_ID = 'chatbot_conversation_id';
export const COOKIE_CONSENT = 'cookie-consent';

export const subscriptionPlans = [
  {
    'id': '67f37e3bc8aad1f236a9cfd6',
    'title': 'Starter',
    'type': 'FREE',
    'subtitle': 'For individuals/hobby use',
    'price': '$0',
    'billingCycle': 'monthly',
    'period': 'per month',
    'features': [
      'For individuals / hobby use',
      'Chatbots: 2',
      'Message Credits: 100/month',
      'Team Seats: 1',
      'Knowledge Base: 100K characters',
      'AI Access: Fast models',
      'Privacy: Public / Private',
      'URL Crawl Limit: 100 Pages/month',
      'Branding: Yes (with branding)',
      'Support: Community',
      'Key Features: Train your AI in minutes',
    ],
  },
  {
    'id': '2',
    'title': 'Pro',
    'type': 'BASIC',
    'subtitle': 'For solo professionals',
    'price': '$39',
    'oldPrice': '$59',
    'billingCycle': 'monthly',
    'period': 'per month',
    'features': [
      'Expert Chatbot: 3',
      'Message Credits: 2000/month',
      'Team Seats: 1',
      'Knowledge Base: 5M characters',
      'AI Access: Advanced models',
      'Privacy: Public / Private',
      'URL Crawl Limit: 10,000 Pages/month',
      'Branding: Yes (with branding)',
      'Support: Email + Community',
      'Key Features: Core for Solo Use',
    ],
  },
  {
    'id': '3',
    'title': 'Business',
    'type': 'PREMIUM',
    'subtitle': 'For small businesses/teams',
    'price': '$249',
    'oldPrice': '$259',
    'billingCycle': 'monthly',
    'period': 'per month',
    'features': [
      'Expert Chatbot: 5',
      'Message Credits: 10,000/month',
      'Team Seats: 10',
      'Knowledge Base: 25M characters',
      'AI Access: Frontier models',
      'Privacy: Public / Private',
      'URL Crawl Limit: 25k Pages/month',
      'Branding: Can be removed',
      'Support: Priority Email / Chat',
      'Key Features: Collaboration, High Limits',
    ],
  },
  {
    'id': '4',
    'title': 'Enterprise',
    'type': 'ENTERPRISE',
    'subtitle': 'For mid-to-large enterprises',
    'price': 'Custom',
    'billingCycle': 'monthly',
    'period': '',
    'features': [
      'Expert Chatbot: 10+ (or Unlimited)',
      'Message Credits: 50k+ / Unlimited',
      'Team Seats: Unlimited',
      'Knowledge Base: Custom',
      'AI Access: Frontier models + custom options',
      'Privacy: Public / Private',
      'URL Crawl Limit: Custom / Unlimited',
      'Branding: Full White-Label',
      'Support: Dedicated Manager + SLA',
      'Key Features: Scale, Security, Customization',
    ],
  },
  {
    'id': '5',
    'title': 'Starter',
    'type': 'FREE',
    'subtitle': 'For individuals/hobby use',
    'price': '$0',
    'billingCycle': 'yearly',
    'period': 'per year',
    'features': [
      'For individuals / hobby use',
      'Chatbots: 2',
      'Message Credits: 100/month',
      'Team Seats: 1',
      'Knowledge Base: 100K characters',
      'AI Access: Fast models',
      'Privacy: Public / Private',
      'URL Crawl Limit: 100 Pages/month',
      'Branding: Yes (with branding)',
      'Support: Community',
      'Key Features: Train your AI in minutes',
    ],
  },
  {
    'id': '6',
    'title': 'Pro',
    'type': 'BASIC',
    'subtitle': 'For solo professionals',
    'price': '$39',
    'billingCycle': 'yearly',
    'oldPrice': '$59',
    'period': 'per year',
    'features': [
      'Expert Chatbot: 3',
      'Message Credits: 2000/month',
      'Team Seats: 1',
      'Knowledge Base: 5M characters',
      'AI Access: Advanced models',
      'Privacy: Public / Private',
      'URL Crawl Limit: 10,000 Pages/month',
      'Branding: Yes (with branding)',
      'Support: Email + Community',
      'Key Features: Core for Solo Use',
    ],
  },
  {
    'id': '67f37e3bc8aad1f236a9cfd6',
    'title': 'Business',
    'type': 'PREMIUM',
    'subtitle': 'For small businesses/teams',
    'price': '$249',
    'billingCycle': 'yearly',
    'oldPrice': '$259',
    'period': 'per year',
    'features': [
      'Expert Chatbot: 5',
      'Message Credits: 10,000/month',
      'Team Seats: 10',
      'Knowledge Base: 25M characters',
      'AI Access: Frontier models',
      'Privacy: Public / Private',
      'URL Crawl Limit: 25k Pages/month',
      'Branding: Can be removed',
      'Support: Priority Email / Chat',
      'Key Features: Collaboration, High Limits',
    ],
  },
  {
    'id': '8',
    'title': 'Enterprise',
    'type': 'ENTERPRISE',
    'subtitle': 'For mid-to-large enterprises',
    'price': 'Custom',
    'billingCycle': 'yearly',
    'period': '',
    'features': [
      'Expert Chatbot: 10+ (or Unlimited)',
      'Message Credits: 50k+ / Unlimited',
      'Team Seats: Unlimited',
      'Knowledge Base: Custom',
      'AI Access: Frontier models + custom options',
      'Privacy: Public / Private',
      'URL Crawl Limit: Custom / Unlimited',
      'Branding: Full White-Label',
      'Support: Dedicated Manager + SLA',
      'Key Features: Scale, Security, Customization',
    ],
  },
];

export const addOnsPlan: AddOnCardDataProps[] = [
  {
    'id': '1',
    'title': 'Extra Message Credits',
    'description': 'Avoid service interruptions when message credits run out',
    'price': '$10',
    'unit': 'per purchase',
    'benefit': '+1,000 message credits',
    'quantityLabel': '1000 messages',
  },
  {
    'id': '2',
    'title': 'Extra Chatbot Instances',
    'description': 'Add more expert chatbots beyond plan limits',
    'price': '$7',
    'unit': 'per month',
    'benefit': '+1 bot/month',
    'quantityLabel': '1 chatbot',
  },
  {
    'id': '3',
    'title': 'Knowledge Base Expansion',
    'description': 'Increase storage capacity',
    'price': '$10',
    'unit': 'per month',
    'benefit': '+1M characters/month',
    'quantityLabel': '1M characters',
  },
  {
    'id': '4',
    'title': 'URL Crawl Boost',
    'description': 'Increase number of crawlable web page',
    'price': '$5',
    'unit': 'per month',
    'benefit': '+1,000 pages/month',
    'quantityLabel': '1000 pages',
  },
  {
    'id': '5',
    'title': 'Branding Removal',
    'description': 'Remove "Powered by" badge',
    'price': '$39',
    'unit': 'per month',
    'benefit': 'Solo & Team Plans Only',
    'quantityLabel': '',
  },
  {
    'id': '6',
    'title': 'Custom Domain for Embed',
    'description': 'Use your own subdomain for widget embed',
    'price': '$59',
    'unit': 'per month',
    'benefit': 'e.g., chat.yoursite.com',
    'quantityLabel': '',
  },
];

export const myBotListDummyData: IChatBot[] = [
  {
    id: '1',
    name: 'Customer Support Chat',
    chatLimit: 500,
    usedNumber: 132,
    progress: 28,
    isPublic: true,
    isActive: true,
    createdAt: '2025-03-03T10:15:00.051Z',
    updatedAt: '2025-02-15T10:15:00.051Z',
    deletedAt: null,
    aiModel: null,
    aiModelId: '',
    appearance: '',
    userId: '',
    chatBotProfilePictures: [],
    domainActive: false,
    domains: [],
    textPrompt: null,
    aiPrompt: null,
    aiPromptId: '',
    rateLimit: {
      enabled: false,
      messages: 0,
      windowMinutes: 0,
      errorMessage: '',
    },
    userFeatureUsage: [],
    customDomain: null,
    customDomainId: null,
    activeCustomDomain: null,
    activeCustomDomainId: null,
    customEmails: null,
    emailDomain: null,
    customEmailsId: null,
    emailDomainId: null,
  },
  {
    id: '2',
    name: 'Energy Regulation Bot',
    chatLimit: 400,
    usedNumber: 210,
    progress: 52,
    isPublic: true,
    isActive: true,
    createdAt: '2025-02-15T10:15:00.051Z',
    updatedAt: '2025-02-15T10:15:00.051Z',
    deletedAt: null,
    aiModel: null,
    aiModelId: '',
    aiPrompt: null,
    aiPromptId: '',
    appearance: '',
    userId: '',
    chatBotProfilePictures: [],
    domainActive: false,
    domains: [],
    textPrompt: null,
    rateLimit: {
      enabled: false,
      messages: 0,
      windowMinutes: 0,
      errorMessage: '',
    },
    userFeatureUsage: [],
    customDomain: null,
    customDomainId: null,
    activeCustomDomain: null,
    activeCustomDomainId: null,
    customEmails: null,
    emailDomain: null,
    customEmailsId: null,
    emailDomainId: null,
  },
  {
    id: '3',
    name: 'NIST Cyber Bot',
    chatLimit: 300,
    usedNumber: 89,
    progress: 28,
    isPublic: true,
    isActive: false,
    createdAt: '2025-01-22T10:15:00.051Z',
    updatedAt: '2025-02-15T10:15:00.051Z',
    deletedAt: null,
    aiModel: null,
    aiModelId: '',
    aiPrompt: null,
    aiPromptId: '',
    appearance: '',
    userId: '',
    chatBotProfilePictures: [],
    domainActive: false,
    domains: [],
    textPrompt: null,
    rateLimit: {
      enabled: false,
      messages: 0,
      windowMinutes: 0,
      errorMessage: '',
    },
    userFeatureUsage: [],
    customDomain: null,
    customDomainId: null,
    activeCustomDomain: null,
    activeCustomDomainId: null,
    customEmails: null,
    emailDomain: null,
    customEmailsId: null,
    emailDomainId: null,
  },
  {
    id: '4',
    name: 'HIPAA Compliance Agent',
    chatLimit: 200,
    usedNumber: 56,
    progress: 30,
    isPublic: true,
    isActive: true,
    createdAt: '2025-04-10T10:15:00.051Z',
    updatedAt: '2025-02-15T10:15:00.051Z',
    deletedAt: null,
    aiModel: null,
    aiModelId: '',
    aiPrompt: null,
    aiPromptId: '',
    appearance: '',
    userId: '',
    chatBotProfilePictures: [],
    domainActive: false,
    domains: [],
    textPrompt: null,
    rateLimit: {
      enabled: false,
      messages: 0,
      windowMinutes: 0,
      errorMessage: '',
    },
    userFeatureUsage: [],
    customDomain: null,
    customDomainId: null,
    activeCustomDomain: null,
    activeCustomDomainId: null,
    customEmails: null,
    emailDomain: null,
    customEmailsId: null,
    emailDomainId: null,
  },
];

export const staffs: IStaff[] = [
  {
    id: '1',
    fullName: 'John Doe',
    email: 'john@example.com',
  },
  {
    id: '2',
    fullName: 'Jane Smith',
    email: 'jane@example.com',
  },
  {
    id: '3',
    fullName: 'Mike Johnson',
    email: 'mike@example.com',
  },
  {
    id: '4',
    fullName: 'Sarah Williams',
    email: 'sarah@example.com',
  },
  {
    id: '5',
    fullName: 'David Brown',
    email: 'david@example.com',
  },
];

export const FEATURE_DISPLAY_NAMES: Record<TFEATURE_NAMES, string> = {
  [FEATURE_NAMES.EXPERT_CHATBOTS]: 'Expert Chatbots',
  [FEATURE_NAMES.MESSAGE_CREDIT]: 'Message Credits',
  [FEATURE_NAMES.TEAM_SEATS]: 'Team Seats',
  [FEATURE_NAMES.KNOWLEDGE_BASE]: 'Knowledge Base',
  [FEATURE_NAMES.URL_CRAWLS]: 'URL Crawls limit',
  [FEATURE_NAMES.DOCUMENT_STUDIO]: 'Document Studio',
  [FEATURE_NAMES.REMOVE_BRANDING]: 'Remove Branding',
  [FEATURE_NAMES.PRIVATE_CHATBOTS]: 'Private Chatbots',
  [FEATURE_NAMES.SUBDOMAIN_ALLOWED]: 'Subdomain Allowed',
  [FEATURE_NAMES.COMMUNITY_SUPPORT]: 'Community Support',
  [FEATURE_NAMES.EMAIL_SUPPORT]: 'Email Support',
  [FEATURE_NAMES.PRIORITY_EMAIL_SUPPORT]: 'Priority Email Support',
  [FEATURE_NAMES.DEDICATED_MANAGER]: 'Dedicated Manager',
  [FEATURE_NAMES.MODELS_ALLOWED]: 'Models Allowed',
  [FEATURE_NAMES.CHATBOTS]: 'Chatbots',
  [FEATURE_NAMES.PRIVACY]: 'Privacy',
  [FEATURE_NAMES.BRANDING]: 'Branding',
  [FEATURE_NAMES.SUPPORT]: 'Support',
  [FEATURE_NAMES.KEY_FEATURES]: 'Key Features',
  [FEATURE_NAMES.FILE_UPLOAD_LIMIT]: 'File Size Limit',
  [FEATURE_NAMES.INSIGHT_TOKENS]: 'Insight Tokens',
  [FEATURE_NAMES.TRANSLATION_TOKENS]: 'Translation Tokens',
};

export const findFeatureUsage = (featureName: TFEATURE_NAMES, featureUsages: IFeatureUsage[]) =>
  featureUsages.find((feature) => feature.featureName === featureName);

export const SUCCESS_PAYMENT_URL = 'https://web.chatdemo.co/payment/success';
export const FAILURE_PAYMENT_URL = 'https://web.chatdemo.co/payment/failure';
export const RETURN_PAYMENT_URL = process.env.NEXT_PUBLIC_APP_URL
  ? `${process.env.NEXT_PUBLIC_APP_URL.trim()}/profile#pricing-plans`
  : 'https://web.chatdemo.co/profile#pricing-plans';

export const chatLogsTableData: IChatLogs[] = [
  {
    id: '1',
    countryName: 'India',
    language: 'English',
    last_message: 'नमस्ते! मैं आपकी कैसे मदद कर सकता हूँ?',
    llm_model: 'GPT-4',
    createdAt: '2025-03-03T10:15:00.051Z',
    countryFlag: 'twemoji:flag-india',
    updatedAt: '2025-03-03T10:15:00.051Z',
    deletedAt: null,
  },
  {
    id: '2',
    countryName: 'Japan',
    language: 'Japanese',
    last_message: 'こんにちは、お元気ですか？',
    llm_model: 'GPT-4',
    createdAt: '2025-01-13T10:11:00.051Z',
    countryFlag: 'twemoji:flag-japan',
    updatedAt: '2025-03-03T10:15:00.051Z',
    deletedAt: null,
  },
  {
    id: '3',
    countryName: 'United States',
    language: 'English',
    last_message: 'Hello, how are you?',
    llm_model: 'CortexAI',
    createdAt: '2025-02-19T10:18:00.051Z',
    countryFlag: 'twemoji:flag-united-states',
    updatedAt: '2025-03-03T10:15:00.051Z',
    deletedAt: null,
  },
  {
    id: '4',
    countryName: 'Australia',
    language: 'English',
    last_message: "G'day! How can I help?",
    llm_model: 'CortexAI',
    createdAt: '2025-01-01T10:14:00.051Z',
    countryFlag: 'twemoji:flag-australia',
    updatedAt: '2025-03-03T10:15:00.051Z',
    deletedAt: null,
  },
  {
    id: '5',
    countryName: 'Germany',
    language: 'German',
    last_message: 'Guten Tag! Wie kann ich Ihnen helfen?',
    llm_model: 'GPT-4',
    createdAt: '2025-03-15T09:30:00.051Z',
    countryFlag: 'twemoji:flag-germany',
    updatedAt: '2025-03-03T10:15:00.051Z',
    deletedAt: null,
  },
  {
    id: '6',
    countryName: 'France',
    language: 'French',
    last_message: 'Bonjour! Comment puis-je vous aider?',
    llm_model: 'CortexAI',
    createdAt: '2025-02-28T14:45:00.051Z',
    countryFlag: 'twemoji:flag-france',
    updatedAt: '2025-03-03T10:15:00.051Z',
    deletedAt: null,
  },
  {
    id: '7',
    countryName: 'Brazil',
    language: 'Portuguese',
    last_message: 'Olá! Como posso ajudar?',
    llm_model: 'GPT-4',
    createdAt: '2025-03-10T11:20:00.051Z',
    countryFlag: 'twemoji:flag-brazil',
    updatedAt: '2025-03-03T10:15:00.051Z',
    deletedAt: null,
  },
  {
    id: '8',
    countryName: 'South Korea',
    language: 'Korean',
    last_message: '안녕하세요! 어떻게 도와드릴까요?',
    llm_model: 'CortexAI',
    createdAt: '2025-02-05T16:55:00.051Z',
    countryFlag: 'twemoji:flag-south-korea',
    updatedAt: '2025-03-03T10:15:00.051Z',
    deletedAt: null,
  },
];

export const MESSAGES_LOGS_HISTORY: Message[] = [
  {
    id: '1',
    content: "Hi! I'm AI bot and I can answer any your questions! How I can help you?",
    type: MessageTypeValues.bot,
  },
  {
    id: '2',
    content: "Hello! I'd like to know more about your services.",
    type: MessageTypeValues.user,
  },
  {
    id: '3',
    content:
      "Of course! I'd be happy to tell you about our services. We offer AI-powered solutions for customer support, data analysis, and process automation. Which area interests you the most?",
    type: MessageTypeValues.bot,
  },
  {
    id: '4',
    content:
      "I'm particularly interested in the customer support solutions. Can you tell me more about that?",
    type: MessageTypeValues.user,
  },
  {
    id: '5',
    content:
      'Our customer support AI can handle multiple customer inquiries simultaneously, provide 24/7 support, and learn from each interaction to improve responses. It can also integrate with your existing CRM systems. Would you like to know about specific features or pricing?',
    type: MessageTypeValues.bot,
  },
  {
    id: '6',
    content: 'Yes, please tell me about the pricing structure.',
    type: MessageTypeValues.user,
  },
  {
    id: '7',
    content:
      'We offer flexible pricing plans based on your needs. Our basic plan starts at $99/month for up to 1,000 interactions. We also have enterprise plans with custom pricing. Would you like me to send you our detailed pricing brochure?',
    type: MessageTypeValues.bot,
  },
  {
    id: '9',
    content: 'Yes, please tell me about the pricing structure.',
    type: MessageTypeValues.user,
  },
  {
    id: '10',
    content:
      'We offer flexible pricing plans based on your needs. Our basic plan starts at $99/month for up to 1,000 interactions. We also have enterprise plans with custom pricing. Would you like me to send you our detailed pricing brochure?',
    type: MessageTypeValues.bot,
  },
];

export const sourceTableData: ISource[] = [
  {
    id: '1',
    status: SOURCE_STATUS.PENDING,
    url: 'https://google.com',
    type: 'url',
    characters: 2500,
    createdAt: '2024-03-15T10:15:00.051Z',
    updatedAt: '2024-03-15T10:15:00.051Z',
    deletedAt: null,
    source: 'https://google.com',
  },
  {
    id: '2',
    status: SOURCE_STATUS.INDEXED,
    url: 'https://web.chatdemo.co',
    type: 'url',
    characters: 15000,
    createdAt: '2024-03-14T09:30:00.051Z',
    updatedAt: '2024-03-14T09:35:00.051Z',
    deletedAt: null,
    source: 'https://web.chatdemo.co',
  },
  {
    id: '3',
    status: SOURCE_STATUS.NO_SPACE,
    url: 'https://facebook.com',
    type: 'url',
    characters: 50000,
    createdAt: '2024-03-13T14:20:00.051Z',
    updatedAt: '2024-03-13T14:25:00.051Z',
    deletedAt: null,
    source: 'https://facebook.com',
  },
  {
    id: '4',
    status: SOURCE_STATUS.FAILED,
    url: 'https://youtube.com',
    type: 'url',
    characters: 0,
    createdAt: '2024-03-12T11:45:00.051Z',
    updatedAt: '2024-03-12T11:50:00.051Z',
    deletedAt: null,
    source: 'https://youtube.com',
  },
  {
    id: '5',
    status: SOURCE_STATUS.INDEXED,
    url: 'https://chatgpt.com',
    type: 'url',
    characters: 30000,
    createdAt: '2024-03-11T16:10:00.051Z',
    updatedAt: '2024-03-11T16:15:00.051Z',
    deletedAt: null,
    source: 'https://chatgpt.com',
  },
  {
    id: '6',
    status: SOURCE_STATUS.PENDING,
    url: 'https://yahoo.com',
    type: 'url',
    characters: 8000,
    createdAt: '2024-03-10T13:25:00.051Z',
    updatedAt: '2024-03-10T13:25:00.051Z',
    deletedAt: null,
    source: 'https://yahoo.com',
  },
  {
    id: '7',
    status: SOURCE_STATUS.INDEXED,
    url: 'https://vimeo.com',
    type: 'url',
    characters: 12000,
    createdAt: '2024-03-09T15:40:00.051Z',
    updatedAt: '2024-03-09T15:45:00.051Z',
    deletedAt: null,
    source: 'https://vimeo.com',
  },
  {
    id: '8',
    status: SOURCE_STATUS.NO_SPACE,
    url: 'https://twitter.com',
    type: 'url',
    characters: 45000,
    createdAt: '2024-03-08T10:55:00.051Z',
    updatedAt: '2024-03-08T11:00:00.051Z',
    deletedAt: null,
    source: 'https://twitter.com',
  },
  {
    id: '9',
    status: SOURCE_STATUS.FAILED,
    url: 'https://instagram.com',
    type: 'url',
    characters: 0,
    createdAt: '2024-03-07T09:15:00.051Z',
    updatedAt: '2024-03-07T09:20:00.051Z',
    deletedAt: null,
    source: 'https://instagram.com',
  },
  {
    id: '10',
    status: SOURCE_STATUS.INDEXED,
    url: 'https://google.com',
    type: 'url',
    characters: 20000,
    createdAt: '2024-03-06T14:30:00.051Z',
    updatedAt: '2024-03-06T14:35:00.051Z',
    deletedAt: null,
    source: 'https://google.com',
  },
];

export const TERMS_CONDITIONS_LIST = [
  {
    id: '1',
    title: 'Acceptance of Terms',
    description:
      'By accessing our services, you confirm that you have read, understood, and agree to comply with these terms.',
  },
  {
    id: '2',
    title: 'User Responsibilities',
    description:
      'You are responsible for keeping your account information confidential and for all actions taken under your account.',
  },
  {
    id: '3',
    title: 'Service Availability',
    description:
      'We aim to provide continuous access to our services, but we cannot guarantee that they will always be available or free of errors.',
  },
  {
    id: '4',
    title: 'Intellectual Property',
    description:
      'All content, trademarks, and other intellectual property related to our services are owned by us or our licensors.',
  },
  {
    id: '5',
    title: 'Limitation of Liability',
    description:
      'We are not responsible for any indirect, incidental, or consequential damages resulting from your use of our services.',
  },
  {
    id: '6',
    title: 'Changes to Terms',
    description:
      'We reserve the right to change these terms at any time. Your continued use of the services after any changes indicates your acceptance of the new terms.',
  },
];

export const CHATBOT_APPEARANCE_DEFAULT_VALUES: AppearanceFormValues = {
  title: '',
  placeholderText: '',
  welcomeMessage: '',
  titleChecked: false,
  placeHolderChecked: false,
  welcomeMessageChecked: false,
  suggestions: [],
  suggestionsChecked: false,
  leadFormChecked: false,
  leadFormFields: {
    title: '',
    formShownAfterMessage: '1',
    nameInput: { isVisible: true, isRequired: false, placeholder: 'Enter Name' },
    emailInput: { isVisible: false, isRequired: false, placeholder: 'Enter Email' },
    phoneInput: {
      isVisible: false,
      isRequired: false,
      placeholder: 'Enter Phone Number',
      defaultCountryCode: '+1',
    },
    messageInput: { isVisible: false, isRequired: false, placeholder: 'Enter Message' },
    submitButtonColor: '#004790',
    submitButtonText: 'Submit',
    thankYouMessage: 'Thank you for your message.',
  },
  brandingCustomization: {
    logo: '',
    chatIconOrientation: 'right',
    chatWindowBgColor: '#F0F8FF',
    userMessageBgColor: '#004790',
    botMessageBgColor: '#FFFFFF',
    sendMessageBtnColor: '#004790',
    chatWindowHeaderBgColor: '#004790',
    messageSound: {
      isEnabled: false,
      sound: 'notification-1',
    },
    embedLauncher: {
      style: 'pill',
      icon: 'brand',
      label: 'Ask AI',
      showLabel: true,
      backgroundColor: '#2B3A67',
      textColor: '#FFFFFF',
      size: 'md',
      horizontalOffset: 10,
      verticalOffset: 10,
    },
    autoOpen: {
      enabled: false,
      delaySeconds: 10,
      frequency: 'once_per_session',
      onMobile: false,
    },
  },
  whiteLabelCustomization: {
    customBranding: {
      isEnabled: false,
      brandingText: '',
    },
    hideDefaultBranding: false,
  },
  showCitations: false,
  webSearchEnabled: true,
  webSearchPublicEnabled: false,
  webSearchThirdPartyFallbackEnabled: false,
  enableDocumentUpload: true, // Default to enabled - users can disable in appearance settings
  allowEndUserModelSelection: true,
  voiceInputEnabled: false,
  voiceOutputEnabled: false,
  voiceLanguage: null,
};

export const VOICE_LANGUAGES = [
  { code: 'en-US', name: 'English (US)' },
  { code: 'en-GB', name: 'English (UK)' },
  { code: 'en-AU', name: 'English (Australia)' },
  { code: 'es-ES', name: 'Spanish (Spain)' },
  { code: 'es-US', name: 'Spanish (US)' },
  { code: 'fr-FR', name: 'French (France)' },
  { code: 'fr-CA', name: 'French (Canada)' },
  { code: 'de-DE', name: 'German' },
  { code: 'it-IT', name: 'Italian' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)' },
  { code: 'ja-JP', name: 'Japanese' },
  { code: 'ko-KR', name: 'Korean' },
  { code: 'zh-CN', name: 'Chinese (Simplified)' },
  { code: 'hi-IN', name: 'Hindi' },
  { code: 'ar-SA', name: 'Arabic' },
] as const;

export const ANALYTICS_PERIOD_DISPLAY_NAMES: Record<TANALYTICS_PERIOD, string> = {
  [ANALYTICS_PERIOD.TODAY]: 'Today',
  [ANALYTICS_PERIOD.THIS_WEEK]: 'This Week',
  [ANALYTICS_PERIOD.THIS_MONTH]: 'This Month',
  [ANALYTICS_PERIOD.THIS_YEAR]: 'This Year',
};

export const ANALYTICS_PERIOD_FILTER_OPTIONS = [
  {
    value: ANALYTICS_PERIOD.TODAY,
    label: ANALYTICS_PERIOD_DISPLAY_NAMES[ANALYTICS_PERIOD.TODAY],
  },
  {
    value: ANALYTICS_PERIOD.THIS_WEEK,
    label: ANALYTICS_PERIOD_DISPLAY_NAMES[ANALYTICS_PERIOD.THIS_WEEK],
  },
  {
    value: ANALYTICS_PERIOD.THIS_MONTH,
    label: ANALYTICS_PERIOD_DISPLAY_NAMES[ANALYTICS_PERIOD.THIS_MONTH],
  },
  {
    value: ANALYTICS_PERIOD.THIS_YEAR,
    label: ANALYTICS_PERIOD_DISPLAY_NAMES[ANALYTICS_PERIOD.THIS_YEAR],
  },
];

export const LANGUAGE_FILTER_OPTIONS = [
  { label: 'Arabic', value: 'Arabic' },
  { label: 'Bulgarian', value: 'Bulgarian' },
  { label: 'Burmese', value: 'Burmese' },
  { label: 'Cantonese (Yue)', value: 'Cantonese (Yue)' },
  { label: 'Chinese (Simplified)', value: 'Chinese (Simplified)' },
  { label: 'Chinese (Traditional)', value: 'Chinese (Traditional)' },
  { label: 'Croatian', value: 'Croatian' },
  { label: 'Czech', value: 'Czech' },
  { label: 'Danish', value: 'Danish' },
  { label: 'Dutch', value: 'Dutch' },
  { label: 'English', value: 'English' },
  { label: 'Estonian', value: 'Estonian' },
  { label: 'Farsi/Persian', value: 'Farsi/Persian' },
  { label: 'Filipino', value: 'Filipino' },
  { label: 'Finnish', value: 'Finnish' },
  { label: 'French', value: 'French' },
  { label: 'German', value: 'German' },
  { label: 'Greek', value: 'Greek' },
  { label: 'Hebrew', value: 'Hebrew' },
  { label: 'Hindi', value: 'Hindi' },
  { label: 'Indonesian', value: 'Indonesian' },
  { label: 'Irish', value: 'Irish' },
  { label: 'Italian', value: 'Italian' },
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Korean', value: 'Korean' },
  { label: 'Latvian', value: 'Latvian' },
  { label: 'Lithuanian', value: 'Lithuanian' },
  { label: 'Macedonian', value: 'Macedonian' },
  { label: 'Maltese', value: 'Maltese' },
  { label: 'Mandarin', value: 'Mandarin' },
  { label: 'Mongolian', value: 'Mongolian' },
  { label: 'Norwegian', value: 'Norwegian' },
  { label: 'Polish', value: 'Polish' },
  { label: 'Portuguese', value: 'Portuguese' },
  { label: 'Romanian', value: 'Romanian' },
  { label: 'Russian', value: 'Russian' },
  { label: 'Serbian', value: 'Serbian' },
  { label: 'Slovak', value: 'Slovak' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'Swedish', value: 'Swedish' },
  { label: 'Tamil', value: 'Tamil' },
  { label: 'Telugu', value: 'Telugu' },
  { label: 'Thai', value: 'Thai' },
  { label: 'Turkish', value: 'Turkish' },
  { label: 'Ukrainian', value: 'Ukrainian' },
  { label: 'Urdu', value: 'Urdu' },
  { label: 'Vietnamese', value: 'Vietnamese' },
  { label: 'Welsh', value: 'Welsh' },
];

export const COUNTRY_CODES = [
  '+1',
  '+20',
  '+27',
  '+31',
  '+32',
  '+33',
  '+34',
  '+39',
  '+41',
  '+43',
  '+44',
  '+46',
  '+47',
  '+48',
  '+49',
  '+52',
  '+54',
  '+55',
  '+60',
  '+61',
  '+62',
  '+63',
  '+64',
  '+65',
  '+66',
  '+81',
  '+82',
  '+84',
  '+86',
  '+88',
  '+91',
  '+92',
  '+94',
  '+234',
  '+254',
  '+880',
  '+966',
  '+971',
];

export const COUNTRY_CODES_OPTIONS = COUNTRY_CODES.map((code) => ({
  value: code,
  label: code,
}));

export const ENTERPRISE_PLAN_DATA: IPlan = {
  id: '1',
  internalId: 'Custom',
  name: 'Enterprise',
  nickname: 'For mid-to-large enterpises',
  type: 'ENTERPRISE',
  price: 0,
  discountedPrice: 0,
  billingCycle: 'MONTHLY',
  createdAt: '2025-05-06T08:54:14.903Z',
  updatedAt: '2025-05-29T07:13:22.199Z',
  deletedAt: null,
  features: [
    {
      id: '11',
      name: 'chatBot',
      description: null,
      quantityLabel: '10+ / Unlimited',
      quantity: 0,
      isUnlimited: false,
      createdAt: '2025-05-29T07:13:22.221Z',
      updatedAt: '2025-05-29T07:13:22.221Z',
      planId: '6819ce36c7a52ca0ba40690e',
      deletedAt: null,
    },
    {
      id: '2',
      name: 'messageCredit',
      description: null,
      quantityLabel: '50k+ / Unlimited',
      quantity: 0,
      isUnlimited: false,
      createdAt: '',
      updatedAt: '',
      planId: '6819ce36c7a52ca0ba40690e',
      deletedAt: null,
    },
    {
      id: '3',
      name: 'teamSeats',
      description: null,
      quantityLabel: 'Unlimited',
      quantity: 0,
      isUnlimited: true,
      createdAt: '',
      updatedAt: '',
      planId: '6819ce36c7a52ca0ba40690e',
      deletedAt: null,
    },
    {
      id: '4',
      name: 'knowledgeBase',
      description: null,
      quantityLabel: 'Custom',
      quantity: 0,
      isUnlimited: false,
      createdAt: '',
      updatedAt: '',
      planId: '6819ce36c7a52ca0ba40690e',
      deletedAt: null,
    },

    {
      id: '5',
      name: 'urlCrawls',
      description: null,
      quantityLabel: 'Custom / Unlimited',
      quantity: 0,
      isUnlimited: false,
      createdAt: '',
      updatedAt: '',
      planId: '6819ce36c7a52ca0ba40690e',
      deletedAt: null,
    },
    {
      id: '6',
      name: 'modelsAllowed',
      description: null,
      quantityLabel: 'Highest tier / Fine-tuned',
      quantity: 0,
      isUnlimited: false,
      createdAt: '',
      updatedAt: '',
      planId: '6819ce36c7a52ca0ba40690e',
      deletedAt: null,
    },
    {
      id: '7',
      name: 'privacy',
      description: null,
      quantityLabel: 'Public / Private',
      quantity: 0,
      isUnlimited: false,
      createdAt: '',
      updatedAt: '',
      planId: '6819ce36c7a52ca0ba40690e',
      deletedAt: null,
    },
    {
      id: '8',
      name: 'branding',
      description: null,
      quantityLabel: 'Full White-Label',
      quantity: 0,
      isUnlimited: true,
      createdAt: '',
      updatedAt: '',
      planId: '6819ce36c7a52ca0ba40690e',
      deletedAt: null,
    },

    {
      id: '9',
      name: 'support',
      description: null,
      quantityLabel: 'Dedicated Manager + SLA',
      quantity: 0,
      isUnlimited: false,
      createdAt: '',
      updatedAt: '',
      planId: '',
      deletedAt: null,
    },
    {
      id: '10',
      name: 'keyFeatures',
      description: null,
      quantityLabel: 'Scale , Security, Customization',
      quantity: 0,
      isUnlimited: false,
      createdAt: '',
      updatedAt: '',
      planId: '6819ce36c7a52ca0ba40690e',
      deletedAt: null,
    },
  ],
  defaultModelId: '',
  priceId: '',
  stripe: null,
  modelPlans: [],
  pageData: {},
};

export const FEATURE_DISPLAY_ADDONS_POSTFIX_TEXT: Partial<Record<TFEATURE_NAMES, string>> = {
  [FEATURE_NAMES.MESSAGE_CREDIT]: 'thousand extra message credits every',
  [FEATURE_NAMES.KNOWLEDGE_BASE]: 'million extra characters every',
  [FEATURE_NAMES.URL_CRAWLS]: 'hundred extra pages every',
  [FEATURE_NAMES.CHATBOTS]: 'extra chatbots every',
  [FEATURE_NAMES.SUBDOMAIN_ALLOWED]: 'e.g., chat.yoursite.com',
  [FEATURE_NAMES.REMOVE_BRANDING]: 'Solo & Team Plans Only',
  [FEATURE_NAMES.FILE_UPLOAD_LIMIT]: 'MB per file every',
  [FEATURE_NAMES.TEAM_SEATS]: 'extra team seat every',
  [FEATURE_NAMES.PRIVATE_CHATBOTS]: 'extra private chatbot every',
};

export const FEATURE_DISPLAY_ADDONS_DESCRIPTION: Partial<Record<TFEATURE_NAMES, string>> = {
  [FEATURE_NAMES.MESSAGE_CREDIT]: 'Avoid service interruptions when message credits run out',
  [FEATURE_NAMES.KNOWLEDGE_BASE]: 'Expand your training storage with more characters per month',
  [FEATURE_NAMES.URL_CRAWLS]: 'Increase the number of crawlable web pages per month',
  [FEATURE_NAMES.CHATBOTS]: 'Add more chatbots beyond your plan limit',
  [FEATURE_NAMES.SUBDOMAIN_ALLOWED]: 'Use your own subdomain for widget embed',
  [FEATURE_NAMES.REMOVE_BRANDING]: 'Remove "Powered by" badge from your chatbot',
  [FEATURE_NAMES.FILE_UPLOAD_LIMIT]: 'Raise the per-file upload limit for training documents',
  [FEATURE_NAMES.TEAM_SEATS]: 'Add more team members beyond your plan limit',
  [FEATURE_NAMES.PRIVATE_CHATBOTS]: 'Add private chatbots accessible only to authorized users',
};

export const countryFlags = [
  { icon: 'flagpack:af', value: 'AF', label: 'Afghanistan' },
  { icon: 'flagpack:al', value: 'AL', label: 'Albania' },
  { icon: 'flagpack:dz', value: 'DZ', label: 'Algeria' },
  { icon: 'flagpack:as', value: 'AS', label: 'American Samoa' },
  { icon: 'flagpack:ad', value: 'AD', label: 'Andorra' },
  { icon: 'flagpack:ao', value: 'AO', label: 'Angola' },
  { icon: 'flagpack:ai', value: 'AI', label: 'Anguilla' },
  { icon: 'flagpack:ag', value: 'AG', label: 'Antigua and Barbuda' },
  { icon: 'flagpack:ar', value: 'AR', label: 'Argentina' },
  { icon: 'flagpack:am', value: 'AM', label: 'Armenia' },
  { icon: 'flagpack:aw', value: 'AW', label: 'Aruba' },
  { icon: 'flagpack:au', value: 'AU', label: 'Australia' },
  { icon: 'flagpack:at', value: 'AT', label: 'Austria' },
  { icon: 'flagpack:az', value: 'AZ', label: 'Azerbaijan' },
  { icon: 'flagpack:bs', value: 'BS', label: 'Bahamas' },
  { icon: 'flagpack:bh', value: 'BH', label: 'Bahrain' },
  { icon: 'flagpack:bd', value: 'BD', label: 'Bangladesh' },
  { icon: 'flagpack:bb', value: 'BB', label: 'Barbados' },
  { icon: 'flagpack:by', value: 'BY', label: 'Belarus' },
  { icon: 'flagpack:be', value: 'BE', label: 'Belgium' },
  { icon: 'flagpack:bz', value: 'BZ', label: 'Belize' },
  { icon: 'flagpack:bj', value: 'BJ', label: 'Benin' },
  { icon: 'flagpack:bm', value: 'BM', label: 'Bermuda' },
  { icon: 'flagpack:bt', value: 'BT', label: 'Bhutan' },
  { icon: 'flagpack:bo', value: 'BO', label: 'Bolivia' },
  { icon: 'flagpack:ba', value: 'BA', label: 'Bosnia and Herzegovina' },
  { icon: 'flagpack:bw', value: 'BW', label: 'Botswana' },
  { icon: 'flagpack:br', value: 'BR', label: 'Brazil' },
  { icon: 'flagpack:bn', value: 'BN', label: 'Brunei' },
  { icon: 'flagpack:bg', value: 'BG', label: 'Bulgaria' },
  { icon: 'flagpack:bf', value: 'BF', label: 'Burkina Faso' },
  { icon: 'flagpack:bi', value: 'BI', label: 'Burundi' },
  { icon: 'flagpack:kh', value: 'KH', label: 'Cambodia' },
  { icon: 'flagpack:cm', value: 'CM', label: 'Cameroon' },
  { icon: 'flagpack:ca', value: 'CA', label: 'Canada' },
  { icon: 'flagpack:cv', value: 'CV', label: 'Cape Verde' },
  { icon: 'flagpack:ky', value: 'KY', label: 'Cayman Islands' },
  { icon: 'flagpack:cf', value: 'CF', label: 'Central African Republic' },
  { icon: 'flagpack:td', value: 'TD', label: 'Chad' },
  { icon: 'flagpack:cl', value: 'CL', label: 'Chile' },
  { icon: 'flagpack:cn', value: 'CN', label: 'China' },
  { icon: 'flagpack:co', value: 'CO', label: 'Colombia' },
  { icon: 'flagpack:km', value: 'KM', label: 'Comoros' },
  { icon: 'flagpack:cg', value: 'CG', label: 'Congo' },
  { icon: 'flagpack:cd', value: 'CD', label: 'Congo (Democratic Republic)' },
  { icon: 'flagpack:cr', value: 'CR', label: 'Costa Rica' },
  { icon: 'flagpack:ci', value: 'CI', label: "Côte d'Ivoire" },
  { icon: 'flagpack:hr', value: 'HR', label: 'Croatia' },
  { icon: 'flagpack:cu', value: 'CU', label: 'Cuba' },
  { icon: 'flagpack:cy', value: 'CY', label: 'Cyprus' },
  { icon: 'flagpack:cz', value: 'CZ', label: 'Czech Republic' },
  { icon: 'flagpack:dk', value: 'DK', label: 'Denmark' },
  { icon: 'flagpack:dj', value: 'DJ', label: 'Djibouti' },
  { icon: 'flagpack:dm', value: 'DM', label: 'Dominica' },
  { icon: 'flagpack:do', value: 'DO', label: 'Dominican Republic' },
  { icon: 'flagpack:ec', value: 'EC', label: 'Ecuador' },
  { icon: 'flagpack:eg', value: 'EG', label: 'Egypt' },
  { icon: 'flagpack:sv', value: 'SV', label: 'El Salvador' },
  { icon: 'flagpack:gq', value: 'GQ', label: 'Equatorial Guinea' },
  { icon: 'flagpack:er', value: 'ER', label: 'Eritrea' },
  { icon: 'flagpack:ee', value: 'EE', label: 'Estonia' },
  { icon: 'flagpack:et', value: 'ET', label: 'Ethiopia' },
  { icon: 'flagpack:fj', value: 'FJ', label: 'Fiji' },
  { icon: 'flagpack:fi', value: 'FI', label: 'Finland' },
  { icon: 'flagpack:fr', value: 'FR', label: 'France' },
  { icon: 'flagpack:ga', value: 'GA', label: 'Gabon' },
  { icon: 'flagpack:gm', value: 'GM', label: 'Gambia' },
  { icon: 'flagpack:ge', value: 'GE', label: 'Georgia' },
  { icon: 'flagpack:de', value: 'DE', label: 'Germany' },
  { icon: 'flagpack:gh', value: 'GH', label: 'Ghana' },
  { icon: 'flagpack:gr', value: 'GR', label: 'Greece' },
  { icon: 'flagpack:gt', value: 'GT', label: 'Guatemala' },
  { icon: 'flagpack:gn', value: 'GN', label: 'Guinea' },
  { icon: 'flagpack:gw', value: 'GW', label: 'Guinea-Bissau' },
  { icon: 'flagpack:gy', value: 'GY', label: 'Guyana' },
  { icon: 'flagpack:ht', value: 'HT', label: 'Haiti' },
  { icon: 'flagpack:hn', value: 'HN', label: 'Honduras' },
  { icon: 'flagpack:hk', value: 'HK', label: 'Hong Kong' },
  { icon: 'flagpack:hu', value: 'HU', label: 'Hungary' },
  { icon: 'flagpack:is', value: 'IS', label: 'Iceland' },
  { icon: 'flagpack:in', value: 'IN', label: 'India' },
  { icon: 'flagpack:id', value: 'ID', label: 'Indonesia' },
  { icon: 'flagpack:ir', value: 'IR', label: 'Iran' },
  { icon: 'flagpack:iq', value: 'IQ', label: 'Iraq' },
  { icon: 'flagpack:ie', value: 'IE', label: 'Ireland' },
  { icon: 'flagpack:il', value: 'IL', label: 'Israel' },
  { icon: 'flagpack:it', value: 'IT', label: 'Italy' },
  { icon: 'flagpack:jm', value: 'JM', label: 'Jamaica' },
  { icon: 'flagpack:jp', value: 'JP', label: 'Japan' },
  { icon: 'flagpack:jo', value: 'JO', label: 'Jordan' },
  { icon: 'flagpack:kz', value: 'KZ', label: 'Kazakhstan' },
  { icon: 'flagpack:ke', value: 'KE', label: 'Kenya' },
  { icon: 'flagpack:kr', value: 'KR', label: 'South Korea' },
  { icon: 'flagpack:kw', value: 'KW', label: 'Kuwait' },
  { icon: 'flagpack:kg', value: 'KG', label: 'Kyrgyzstan' },
  { icon: 'flagpack:la', value: 'LA', label: 'Laos' },
  { icon: 'flagpack:lv', value: 'LV', label: 'Latvia' },
  { icon: 'flagpack:lb', value: 'LB', label: 'Lebanon' },
  { icon: 'flagpack:lr', value: 'LR', label: 'Liberia' },
  { icon: 'flagpack:ly', value: 'LY', label: 'Libya' },
  { icon: 'flagpack:li', value: 'LI', label: 'Liechtenstein' },
  { icon: 'flagpack:lt', value: 'LT', label: 'Lithuania' },
  { icon: 'flagpack:lu', value: 'LU', label: 'Luxembourg' },
  { icon: 'flagpack:mo', value: 'MO', label: 'Macao' },
  { icon: 'flagpack:mg', value: 'MG', label: 'Madagascar' },
  { icon: 'flagpack:mw', value: 'MW', label: 'Malawi' },
  { icon: 'flagpack:my', value: 'MY', label: 'Malaysia' },
  { icon: 'flagpack:mv', value: 'MV', label: 'Maldives' },
  { icon: 'flagpack:ml', value: 'ML', label: 'Mali' },
  { icon: 'flagpack:mt', value: 'MT', label: 'Malta' },
  { icon: 'flagpack:mh', value: 'MH', label: 'Marshall Islands' },
  { icon: 'flagpack:mr', value: 'MR', label: 'Mauritania' },
  { icon: 'flagpack:mu', value: 'MU', label: 'Mauritius' },
  { icon: 'flagpack:mx', value: 'MX', label: 'Mexico' },
  { icon: 'flagpack:fm', value: 'FM', label: 'Micronesia' },
  { icon: 'flagpack:md', value: 'MD', label: 'Moldova' },
  { icon: 'flagpack:mc', value: 'MC', label: 'Monaco' },
  { icon: 'flagpack:mn', value: 'MN', label: 'Mongolia' },
  { icon: 'flagpack:me', value: 'ME', label: 'Montenegro' },
  { icon: 'flagpack:ma', value: 'MA', label: 'Morocco' },
  { icon: 'flagpack:mz', value: 'MZ', label: 'Mozambique' },
  { icon: 'flagpack:mm', value: 'MM', label: 'Myanmar' },
  { icon: 'flagpack:na', value: 'NA', label: 'Namibia' },
  { icon: 'flagpack:np', value: 'NP', label: 'Nepal' },
  { icon: 'flagpack:nl', value: 'NL', label: 'Netherlands' },
  { icon: 'flagpack:nz', value: 'NZ', label: 'New Zealand' },
  { icon: 'flagpack:ni', value: 'NI', label: 'Nicaragua' },
  { icon: 'flagpack:ne', value: 'NE', label: 'Niger' },
  { icon: 'flagpack:ng', value: 'NG', label: 'Nigeria' },
  { icon: 'flagpack:no', value: 'NO', label: 'Norway' },
  { icon: 'flagpack:om', value: 'OM', label: 'Oman' },
  { icon: 'flagpack:pk', value: 'PK', label: 'Pakistan' },
  { icon: 'flagpack:pw', value: 'PW', label: 'Palau' },
  { icon: 'flagpack:pa', value: 'PA', label: 'Panama' },
  { icon: 'flagpack:pg', value: 'PG', label: 'Papua New Guinea' },
  { icon: 'flagpack:py', value: 'PY', label: 'Paraguay' },
  { icon: 'flagpack:pe', value: 'PE', label: 'Peru' },
  { icon: 'flagpack:ph', value: 'PH', label: 'Philippines' },
  { icon: 'flagpack:pl', value: 'PL', label: 'Poland' },
  { icon: 'flagpack:pt', value: 'PT', label: 'Portugal' },
  { icon: 'flagpack:qa', value: 'QA', label: 'Qatar' },
  { icon: 'flagpack:ro', value: 'RO', label: 'Romania' },
  { icon: 'flagpack:ru', value: 'RU', label: 'Russia' },
  { icon: 'flagpack:rw', value: 'RW', label: 'Rwanda' },
  { icon: 'flagpack:kn', value: 'KN', label: 'Saint Kitts and Nevis' },
  { icon: 'flagpack:lc', value: 'LC', label: 'Saint Lucia' },
  { icon: 'flagpack:vc', value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { icon: 'flagpack:ws', value: 'WS', label: 'Samoa' },
  { icon: 'flagpack:sm', value: 'SM', label: 'San Marino' },
  { icon: 'flagpack:st', value: 'ST', label: 'Sao Tome and Principe' },
  { icon: 'flagpack:sa', value: 'SA', label: 'Saudi Arabia' },
  { icon: 'flagpack:sn', value: 'SN', label: 'Senegal' },
  { icon: 'flagpack:rs', value: 'RS', label: 'Serbia' },
  { icon: 'flagpack:sc', value: 'SC', label: 'Seychelles' },
  { icon: 'flagpack:sl', value: 'SL', label: 'Sierra Leone' },
  { icon: 'flagpack:sg', value: 'SG', label: 'Singapore' },
  { icon: 'flagpack:sk', value: 'SK', label: 'Slovakia' },
  { icon: 'flagpack:si', value: 'SI', label: 'Slovenia' },
  { icon: 'flagpack:sb', value: 'SB', label: 'Solomon Islands' },
  { icon: 'flagpack:so', value: 'SO', label: 'Somalia' },
  { icon: 'flagpack:za', value: 'ZA', label: 'South Africa' },
  { icon: 'flagpack:es', value: 'ES', label: 'Spain' },
  { icon: 'flagpack:lk', value: 'LK', label: 'Sri Lanka' },
  { icon: 'flagpack:sd', value: 'SD', label: 'Sudan' },
  { icon: 'flagpack:sr', value: 'SR', label: 'Suriname' },
  { icon: 'flagpack:sz', value: 'SZ', label: 'Swaziland' },
  { icon: 'flagpack:se', value: 'SE', label: 'Sweden' },
  { icon: 'flagpack:ch', value: 'CH', label: 'Switzerland' },
  { icon: 'flagpack:sy', value: 'SY', label: 'Syria' },
  { icon: 'flagpack:tw', value: 'TW', label: 'Taiwan' },
  { icon: 'flagpack:tj', value: 'TJ', label: 'Tajikistan' },
  { icon: 'flagpack:tz', value: 'TZ', label: 'Tanzania' },
  { icon: 'flagpack:th', value: 'TH', label: 'Thailand' },
  { icon: 'flagpack:tl', value: 'TL', label: 'Timor-Leste' },
  { icon: 'flagpack:tg', value: 'TG', label: 'Togo' },
  { icon: 'flagpack:to', value: 'TO', label: 'Tonga' },
  { icon: 'flagpack:tt', value: 'TT', label: 'Trinidad and Tobago' },
  { icon: 'flagpack:tn', value: 'TN', label: 'Tunisia' },
  { icon: 'flagpack:tr', value: 'TR', label: 'Turkey' },
  { icon: 'flagpack:tm', value: 'TM', label: 'Turkmenistan' },
  { icon: 'flagpack:tv', value: 'TV', label: 'Tuvalu' },
  { icon: 'flagpack:ug', value: 'UG', label: 'Uganda' },
  { icon: 'flagpack:ua', value: 'UA', label: 'Ukraine' },
  { icon: 'flagpack:ae', value: 'AE', label: 'United Arab Emirates' },
  { icon: 'flagpack:gb', value: 'GB', label: 'United Kingdom' },
  { icon: 'flagpack:us', value: 'US', label: 'United States' },
  { icon: 'flagpack:uy', value: 'UY', label: 'Uruguay' },
  { icon: 'flagpack:uz', value: 'UZ', label: 'Uzbekistan' },
  { icon: 'flagpack:vu', value: 'VU', label: 'Vanuatu' },
  { icon: 'flagpack:ve', value: 'VE', label: 'Venezuela' },
  { icon: 'flagpack:vn', value: 'VN', label: 'Vietnam' },
  { icon: 'flagpack:ye', value: 'YE', label: 'Yemen' },
  { icon: 'flagpack:zm', value: 'ZM', label: 'Zambia' },
  { icon: 'flagpack:zw', value: 'ZW', label: 'Zimbabwe' },
  { icon: 'flagpack:ps', value: 'PS', label: 'Palestine' },
  { icon: 'flagpack:pr', value: 'PR', label: 'Puerto Rico' },
  { icon: 'flagpack:re', value: 'RE', label: 'Réunion' },
  { icon: 'flagpack:mf', value: 'MF', label: 'Saint Martin' },
  { icon: 'flagpack:yt', value: 'YT', label: 'Mayotte' },
  { icon: 'flagpack:bl', value: 'BL', label: 'Saint Barthélemy' },
];

export const DNS_CONFIG_VALUES = [
  {
    id: '1',
    status: 'pending',
    domain: 'example.com',
    cName: 'w6vfal7uh2luntx4zokx36fjfmrzchtb._domainkey',
    cValue: 'w6vfal7uh2luntx4zokx36fjfmrzchtb.dkim.amazonses.com',
  },
  {
    id: '2',
    status: 'pending',
    domain: 'example.com',
    cName: 'w6vfa32wsl7uh2luntx4zokx36fjfmrzchtb._domainkey',
    cValue: 'w6vfadsxwl7uh2luntx4zokx36fjfmrzchtb.dkim.amazonses.com',
  },
  {
    id: '3',
    status: 'verified',
    domain: 'example.com',
    cName: 'w632vfa32wsl7uh2luntx4zokx36fjfmrzchtb._domainkey',
    cValue: 'w6fewvfadsxwl7uh2luntx4zokx36fjfmrzchtb.dkim.amazonses.com',
  },
];
export const DOMAIN_MAPPED_LIST = [
  {
    value: 'chat.chatdemo.co',
    label: 'chat.chatdemo.co',
  },
  {
    value: 'chat1.chatdemo.co',
    label: 'chat1.chatdemo.co',
  },
  {
    value: 'chat2.chatdemo.co',
    label: 'chat2.chatdemo.co',
  },
];

export const SOUND_OPTION_LIST = [
  {
    label: 'Notification 1',
    value: 'notification-1',
    url: '/assets/sound/notification1.mp3',
  },
  {
    label: 'Notification 2',
    value: 'notification-2',
    url: '/assets/sound/notification2.mp3',
  },
  {
    label: 'Notification 3',
    value: 'notification-3',
    url: '/assets/sound/notification3.mp3',
  },
];
